module.exports = __webpack_public_path__ + "static/media/lamp_on.0a2f1996.png";